import React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import { steps } from '../../Constants/Steps';
import { getSelectedStage } from '../../Reducers/Configurator/Selectors';
import { useSelector } from 'react-redux';
import { T } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { useMediaQuery, useTheme } from '@material-ui/core';

const StyledTabs = withStyles({
  indicator: {
    display: 'none',
  },
})(Tabs);

const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: 'uppercase',
    minWidth: 0,
    padding: '0 8px 0 0',
    transform: 'scale(1.8) translate(17px, 0px)',
    pointerEvents: 'none',
    marginRight: 100,
    marginLeft: 40,
    fontWeight: '700',
    [theme.breakpoints.down('xs')]: {
      fontSize: 14,
    },
    [theme.breakpoints.down('md')]: {
      fontSize: 18,
      transform: 'scale(1) translate(0px, 0px)',
      margin: theme.spacing(0, 2),
    },
  },
  wrapper: {
    alignItems: 'flex-start',
  },
}))(Tab);

const useStyles = makeStyles({
  left: {
    color: 'black',
  },
  loadInprogress: {
    '& button': {
      cursor: 'wait',
    },
  },
});

export const StageTabs = ({ className }) => {
  const selectedStage = useSelector(getSelectedStage);
  const { isLoading } = useSelector((state) => state.configurator);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const selectedIndex = steps.indexOf(selectedStage);
  const classes = useStyles();
  const stages = isSmallScreen ? [selectedStage] : steps;
  return (
    <StyledTabs className={clsx(className, isLoading && classes.loadInprogress)} value={selectedStage}>
      {stages.map((step, idx) => (
        <StyledTab
          key={step}
          label={T(`steps.${step}`)}
          value={step}
          disableRipple
          disableFocusRipple
          className={clsx(idx < selectedIndex && classes.left)}
          textColor="primary"
        />
      ))}
    </StyledTabs>
  );
};

StageTabs.propTypes = {
  className: PropTypes.string,
};

export default StageTabs;
